import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { Stack, Chip, Button, Typography, styled, IconButton } from '@mui/material'
import { alertError } from '../alert/swal'
import HelperText from '../input/helperText'
import { colors } from '../../constants/colors'
import { icons } from '../../assets/icons/icons'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import { FileAttachmentApi } from '../../api/file-attachment/fileAttachment.api'
// import { useDispatch, useSelector } from 'react-redux'
// import { setLoading } from '../../store/loading/loading.slice'
// import { useOnLoadImages } from '../loading/useLoadImage'
import { useTranslation } from 'react-i18next'

const UploadFileContainer = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: "center"
    },
    '.upload-file-content': {
        [theme.breakpoints.down('md')]: {
            textAlign: "center",
            flexDirection: "column"
        }
    }
}))

type Props = {
    heading?: string;
    onDrop: (data: any) => void;
    file?: any
    onDeleteFile?: () => void;
    fileAttachmentId?: number;
    fileAttachmentName?: string;
    noClick?: boolean;
    required?: boolean;
    helperText?: string;
    hidden?: boolean
    dispatchLoading?: any
    xlSize?: boolean;
    formatText?: string;
    enableFormatImage?: boolean;
    showImage?: boolean;
    fileName?: string;
    pathImage?: string;
    formatValidate?: string[];
    onDeleteFileId?: () => void;
    disableDeleteFileId?: boolean;
    notFoundFileText?: string;
    containerHeight?: string;
    onDownloadFile?: () => void;
    hiddenDownloadFile?: boolean;
    viewButtonWithPath?: string;
    customViewButtonWithPath?: string;
    customFormat?: string[];
    onlyPdf?: boolean;
    customHeading?: React.ReactNode;
}



const UploadFile: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    // const dispatch = useDispatch();
    const wrapperRef = useRef<HTMLDivElement>(null);
    // const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    // const imageLoading = useOnLoadImages(wrapperRef);
    const [loaded, setLoaded] = useState<boolean>(false);


    const [imageUrl, setImageUrl] = useState<string>("");
    const allowedTypes: string[] = props.formatValidate ? props.formatValidate : props.enableFormatImage ?
        [
            'image/jpeg',
            'image/jpg',
            'image/png',
            ...(props.customFormat ? props.customFormat : [])
        ]
        :
        [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ...(props.customFormat ? props.customFormat : [])
        ];
    const onDrop = useCallback((acceptedFiles: any) => {
        const file = acceptedFiles[0];
        if (file) {
            if (!allowedTypes.includes(file.type)) {
                alertError(t('รูปแบบไฟล์ไม่ถูกต้องกรุณาตรวจสอบ'))
                return;
            }
            const maxSize = 10 * 1024 * 1024; // 10 MB
            if (file.size > maxSize) {
                alertError(t('ขนาดไฟล์ใหญ่เกินไป'))
                return;
            }

            props.onDrop(acceptedFiles);
        }
    }, [props]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxFiles: 1,
        ...(props.enableFormatImage ? {
            accept: {
                'image/png': ['.png', '.jpeg', '.jpg'],
            },
        } : {}),
        ...(props.onlyPdf && {
            accept: {
                'application/pdf': ['.pdf']
            }
        }),
        ...(props.noClick ? { noClick: true } : {}),
    })

    const handleDownloadFile = async (fileId: number, fileName: string) => {
        // dispatch(setLoading());
        // await FileAttachmentApi.download(fileId)
        //     .then(res => {
        //         if (res.status === 200) {
        //             const data = res.data;
        //             let fileType;
        //             let fileExtension;
        //             const contentType = res.headers["content-type"];
        //             switch (contentType) {
        //                 case "application/pdf":
        //                     fileType = "application/pdf";
        //                     fileExtension = ".pdf";
        //                     break;
        //                 case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        //                     fileType =
        //                         "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        //                     fileExtension = ".docx";
        //                     break;
        //                 case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        //                     fileType =
        //                         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        //                     fileExtension = ".xlsx";
        //                     break;
        //                 default:
        //                     throw new Error("Unsupported file type");
        //             }
        //             dispatch(unsetLoading())
        //             const blob = new Blob([data], { type: fileType });
        //             saveAs(blob, fileName);
        //         }
        //     }).catch((error) => {
        //         dispatch(unsetLoading());
        //         console.log(error);
        //         swalError('เกิดข้อผิดพลาดในการดาวน์โหลด');
        //     })
    }


    // ใช้แก้ไข
    // const getFile = async () => {
    //     const res = await FileAttachmentAPI.download(props.detail?.coverFileAttachment?.fileAttachmentId);
    //     const blobFile = new Blob([res?.data], { type: props.detail?.coverFileAttachment?.fileType })
    //     setCoverPhoto((prev) => ({
    //         ...prev,
    //         fileAttachmentId: props.detail?.coverFileAttachment?.fileAttachmentId,
    //         fileAttachmentName: props.detail?.coverFileAttachment?.fileName,
    //         file: [blobFile]

    //     }))
    // }
    // getFile();

    useEffect(() => {
        if (props.file && props.file.length > 0) {
            const file = props.file[0];
            const url = URL.createObjectURL(file);
            setImageUrl(url);
            return () => {
                URL.revokeObjectURL(url);
            };
        }
    }, [props.file]);

    return (
        <>
            <div style={{ display: props.hidden ? 'none' : 'block' }} className='w-full'>
                {props.heading && (
                    <div className='my-2 flex justify-start items-center gap-4'>
                        <Typography>{props.heading}</Typography>
                        {props.required && <Typography sx={{ color: colors.danger }}>*</Typography>}
                    </div>
                )}
                {props.customHeading && (
                    <>
                        {props.customHeading}
                    </>
                )}
                <div className={`${props.containerHeight && `lg:h-[${props.containerHeight}]`}`} style={{
                    // pointerEvents: props.fileAttachmentId ? 'none' : 'all',
                    border: "2px dotted #C1C3C7",
                    borderRadius: "10px",
                    padding: "15px 15px"
                }} {...getRootProps()}>
                    {props.showImage && props.file && props.file[0]?.type !== 'application/pdf' ?
                        <>
                            {props.file &&
                                <div ref={wrapperRef} className={`${props.containerHeight && `lg:h-[${props.containerHeight}]`} flex justify-center items-center relative`}>
                                    {props.onDeleteFile && (
                                        <Chip
                                            sx={{ position: "absolute", top: "0", right: "0" }}
                                            onDelete={props.onDeleteFile}
                                            label={t("ลบ")}
                                        />
                                    )}
                                    {/* {!imageLoading ? */}
                                    <img
                                        loading='lazy'
                                        src={imageUrl}
                                        onLoad={() => setLoaded(true)}
                                        style={{
                                            width: "100%",
                                            margin: "auto",
                                            objectFit: "contain",
                                            transition: 'filter 0.8s ease-out',

                                            filter: loaded ? 'none' : 'blur(10px)',
                                        }}
                                        alt='image-preview'
                                    />
                                    {/* : */}
                                    {/* <Skeleton
                                            animation="wave"
                                            height={500}
                                            width="100%"
                                            style={{ marginBottom: 6 }}
                                        />
                                    } */}
                                </div>
                            }
                        </>
                        :
                        <>
                            <UploadFileContainer
                                className={`flex-wrap md:flex-nowrap ${props.xlSize ? `${props.containerHeight && `lg:h-[${props.containerHeight}]`} flex justify-center flex-col items-center text-center gap-3` : `${props.containerHeight && `lg:h-[${props.containerHeight}]`} flex justify-between gap-3`}`}>
                                <div className={`
                        ${props.xlSize ? 'upload-file-content flex flex-col justify-center items-center gap-3' :
                                        'upload-file-content flex gap-3 justify-start items-center'}`}>

                                    <span>
                                        <img width={48} height={48} src={icons.UploadCloudBig} alt="icon" />
                                    </span>
                                    <span className='flex justify-center flex-col'>
                                        {isDragActive ?
                                            <>
                                                <Typography sx={{ color: "#323539", fontSize: "14px", fontWeight: "500" }}>
                                                    {t("วางไฟล์ลงที่นี่")}
                                                </Typography>
                                                <Typography sx={{ color: 'rgba(0,0,0,0.40)', fontSize: '14px', fontWeight: "300" }}>
                                                    {"Drop the file here."}
                                                </Typography>
                                            </> :
                                            <>
                                                {props?.fileAttachmentId && props.fileAttachmentName ?
                                                    <>
                                                        {`${props.fileAttachmentName?.length > 34 ? props.fileAttachmentName?.substring(0, 34) + "..." : props.fileAttachmentName}`}
                                                    </> :
                                                    <>
                                                        {props.notFoundFileText ?
                                                            <>
                                                                <Typography sx={{ color: "#323539", fontSize: "14px", fontWeight: "500" }}>
                                                                    {`${props.notFoundFileText}`}
                                                                </Typography>
                                                            </>
                                                            :
                                                            <>
                                                                <Typography sx={{ color: "#323539", fontSize: "14px", fontWeight: "500" }}>
                                                                    {t("FILE_UPLOAD.SELECT_FILE")}
                                                                </Typography>
                                                                <Typography sx={{ color: 'rgba(0,0,0,0.40)', fontSize: '14px', fontWeight: "300" }}>
                                                                    {props.formatText ? t(props.formatText) : t("Word, Excel or PDF ขนาดไม่เกิน 10MB")}
                                                                </Typography>
                                                            </>
                                                        }

                                                    </>
                                                }

                                            </>
                                        }
                                    </span>
                                    <span>
                                        <Stack spacing={1}>
                                            {props.file && !props.fileAttachmentId ?
                                                <Chip
                                                    onClick={() => {
                                                        if (props.file && props.file[0] && props.file[0].type === 'application/pdf') {
                                                            const file = new Blob([props.file[0]], { type: "application/pdf" });
                                                            window.open(URL.createObjectURL(file), "_blank");
                                                        } else {
                                                            return;
                                                        }
                                                    }}
                                                    onDelete={props.onDeleteFile}
                                                    label={props.file[0]?.name || props.fileName}
                                                />
                                                :
                                                <>
                                                </>
                                            }
                                            {props.fileAttachmentId
                                                &&
                                                props.fileAttachmentName &&
                                                <>
                                                    {/* <Chip
                                                label={props.fileAttachmentName?.length > 34 ? props.fileAttachmentName?.substring(0, 34) + "..." : props.fileAttachmentName}
                                            /> */}
                                                </>
                                            }
                                        </Stack>
                                    </span>
                                </div>
                                <div className='flex justify-center items-center'>
                                    {props?.fileAttachmentId && props.fileAttachmentName ?
                                        <div className='flex justify-end items-center gap-2'>
                                            {!props.hiddenDownloadFile && (
                                                <Button
                                                    sx={{
                                                        color: "#0F9F0C",
                                                        borderColor: "#0F9F0C",
                                                        textTransform: "none"
                                                    }}
                                                    onClick={async (event) => {
                                                        event.stopPropagation();
                                                        props.onDownloadFile ? props.onDownloadFile() : handleDownloadFile(props?.fileAttachmentId || 0, props.fileAttachmentName || '')
                                                    }}
                                                    variant='outlined' color='primary'>
                                                    {t("BUTTON.DOWNLOAD_FILE")}
                                                </Button>
                                            )}
                                            {props.viewButtonWithPath && !props.onDeleteFileId && (
                                                <IconButton onClick={() => window.open(props.customViewButtonWithPath ? props.customViewButtonWithPath : `${process.env.REACT_APP_FILE_BASE_API}/${props.viewButtonWithPath}`)}>
                                                    <RemoveRedEyeOutlinedIcon />
                                                </IconButton>
                                            )}
                                            {props.onDeleteFileId && (
                                                <Button
                                                    sx={{ textTransform: "none" }}
                                                    disabled={props.disableDeleteFileId}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        props.onDeleteFileId && props.onDeleteFileId()
                                                    }}
                                                    variant='outlined' color='error'>
                                                    {t("BUTTON.DELETE")}
                                                </Button>
                                            )}
                                        </div>
                                        :
                                        <>
                                            {!props.notFoundFileText && !props.file && (
                                                <Button disabled={props.noClick} variant='outlined' sx={{ border: `1px solid ${colors.success3}`, color: colors.success3, textTransform: 'none' }} color='primary'>
                                                    {t("BUTTON.SELECT_FILE")}
                                                </Button>
                                            )}
                                        </>
                                    }

                                </div>
                            </UploadFileContainer>
                        </>
                    }
                    <input accept='.xlsx,.xls,pdf,.docx' multiple={false} {...getInputProps()} />
                </div>
                {props.helperText ? <HelperText label={props.helperText} /> : ""}
            </div>
        </>
    )
}

export default UploadFile

